import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/applications/ApplicationTeaser.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/BlockLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/ToolboxCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendarWithFilters"] */ "/vercel/path0/src/features/events/components/calendar-with-filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendarView"] */ "/vercel/path0/src/features/events/components/calendar/calendar-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DayView"] */ "/vercel/path0/src/features/events/components/calendar/day-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MonthView"] */ "/vercel/path0/src/features/events/components/calendar/month-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WeekView"] */ "/vercel/path0/src/features/events/components/calendar/week-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventCard"] */ "/vercel/path0/src/features/events/components/event-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventThemeCard"] */ "/vercel/path0/src/features/events/components/event-theme-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsFilters"] */ "/vercel/path0/src/features/events/components/events-filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsList"] */ "/vercel/path0/src/features/events/components/events-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsThemeBlockClient"] */ "/vercel/path0/src/features/events/components/events-theme-block-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsCard"] */ "/vercel/path0/src/features/news/components/news-card/news-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectCard"] */ "/vercel/path0/src/features/projects/components/project-card/project-card.tsx");
